<template>
  <header>
    <nav class="main-nav container-fluid nav-s" :class="{'fixed-navbar': fixed}">
      <div id="main-nav" class="row d-flex justify-content-between align-items-center">
        <!-- Logo -->
        <router-link to="/" id="logo" class="col-9 col-lg-3 d-flex align-items-center justify-content-center logo"  @click="goHome">
          <img id="logo-nav" class="me-3 col-6" style="width: 75px;" src="/img/LogoAMpeq.png" alt="Logo Andrés" />
          <p id="name-nav" class="col-6 d-flex align-items-center "><b>ANDRÉS</b> MOLINA</p>
        </router-link>

        <!-- Nav center (desktop) -->
        <div class="col-6 d-none d-lg-flex align-items-center justify-content-center center-nav">
          <router-link to="/about-me" class="main-nav-link me-4" @click="closeIfMobile">ACERCA DE MÍ</router-link>
          <router-link to="/services" class="main-nav-link me-4"  @click="closeIfMobile">SERVICIOS</router-link>
          <router-link to="/portfolio" class="main-nav-link me-4"  @click="closeIfMobile">PROYECTOS</router-link>
          <router-link to="/contact" class="main-nav-link me-4"  @click="closeIfMobile">CONTÁCTAME</router-link>
        </div>

        <!-- Nav final (desktop) -->
        <div class="col-3 d-none d-lg-flex justify-content-center final-nav">
          <a href="https://github.com/andres15mol" target="_blank" class="iconos-apps"><i class="me-4 fa-brands fa-github"></i></a>
          <a href="https://www.linkedin.com/in/andrés-alejandro-molina-039276230" target="_blank" class="iconos-apps"><i class="me-3 fa-brands fa-linkedin"></i></a>
        </div>

        <!-- Botón hamburguesa (mobile) -->
        <button
          class="col-3 btn-mobile-nav d-lg-none"
          id="btnMobileNav"
          @click="toggleNav"
          @mouseover="hoverMobileBtn(true)"
          @mouseout="hoverMobileBtn(false)"
          :aria-expanded="isOpen.toString()"
          aria-controls="bot-nav"
          aria-label="Toggle navigation"
        >
          <i class="fa-solid fa-bars"></i>
        </button>
      </div>

      <!-- Menú móvil -->
      <div
        id="bot-nav"
        class="row"
        v-show="isOpen"
        :class="{'mostrar': isOpen}"
        :style="botNavStyle"
      >
        <div class="col-12 d-flex flex-column align-items-center py-3">
          <router-link to="/about-me" class="main-nav-link me-4" @click="closeIfMobile">ACERCA DE MÍ</router-link>
          <router-link to="/services" class="main-nav-link me-4"  @click="closeIfMobile">SERVICIOS</router-link>
          <router-link to="/portfolio" class="main-nav-link me-4"  @click="closeIfMobile">PROYECTO</router-link>
          <router-link to="/contact" class="main-nav-link me-4"  @click="closeIfMobile">CONTÁCTAME</router-link>

          <div class="d-flex justify-content-center mt-3">
            <a href="https://github.com/andres15mol" target="_blank" class="iconos-apps"><i class="me-4 fa-brands fa-github"></i></a>
            <a href="https://www.linkedin.com/in/andrés-alejandro-molina-039276230" target="_blank" class="iconos-apps"><i class="me-3 fa-brands fa-linkedin"></i></a>
          </div>
        </div>
        <!-- <div class="col-6 d-none d-lg-flex align-items-center justify-content-center center-nav">
          <router-link to="/about-me" class="main-nav-link me-4" @click="closeIfMobile">ACERCA DE MÍ</router-link>
          <router-link to="/services" class="main-nav-link me-4"  @click="closeIfMobile">SERVICIOS</router-link>
          <router-link to="/portfolio" class="main-nav-link me-4"  @click="closeIfMobile">PROYECTO</router-link>
          <router-link to="/contact" class="main-nav-link me-4"  @click="closeIfMobile">CONTÁCTAME</router-link>
        </div> -->
      </div>
    </nav>
  </header>
</template>

<script>
import { store } from './store.js'
import router from '../router/index.js'
import Security from './security'

export default {
  data() {
    return {
      store,
      isOpen: false,
      fixed: false,
      botNavBg: '#2d2e32', // color cerrado
      resizeHandler: null,
      scrollHandler: null,
      mousemoveAttached: false,
    }
  },
  computed: {
    botNavStyle() {
      return {
        backgroundColor: this.isOpen ? 'rgb(37, 37, 37)' : this.botNavBg,
        transition: 'background-color .2s ease',
      }
    },
  },
  mounted() {
    // resize -> cerrar menú al pasar a desktop
    this.resizeHandler = () => {
      const w = window.innerWidth
      if (w > 992 && this.isOpen) {
        this.isOpen = false
        this.botNavBg = '#2d2e32'
      }
    }
    window.addEventListener('resize', this.resizeHandler)

    // scroll -> navbar fija después del hero/contact-me
    this.scrollHandler = () => {
      const navbarEl = document.querySelector('.main-nav')
      const pivot = document.querySelector('.contact-me') || document.querySelector('#services') || document.body
      if (!navbarEl || !pivot) return
      const limit = pivot.offsetTop + pivot.offsetHeight
      this.fixed = window.pageYOffset >= limit
    }
    window.addEventListener('scroll', this.scrollHandler)
    this.scrollHandler()

    // Opcional: moverImagen(event) si el contenedor existe
    const contenedor = document.getElementById('contenedor')
    if (contenedor) {
      contenedor.addEventListener('mousemove', this.moverImagen)
      this.mousemoveAttached = true
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resizeHandler)
    window.removeEventListener('scroll', this.scrollHandler)

    const contenedor = document.getElementById('contenedor')
    if (this.mousemoveAttached && contenedor) {
      contenedor.removeEventListener('mousemove', this.moverImagen)
    }
  },
  methods: {
    // ====== HEADER ======
    toggleNav() {
      this.isOpen = !this.isOpen
      // Cambia color de fondo al abrir/cerrar
      if (this.isOpen) {
        this.botNavBg = 'rgb(37, 37, 37)'
      } else {
        // pequeña espera para que se vea la transición si tienes animación CSS
        setTimeout(() => (this.botNavBg = '#2d2e32'), 220)
      }

      
    },
    closeIfMobile() {
      
      if (window.innerWidth < 992 ) {
        this.toggleNav()

        const botNav = document.getElementById('bot-nav');

        botNav.classList.toggle('d-none', !this.isOpen);
        botNav.classList.toggle('mostrar', this.isOpen);

        
      }
    },
    hoverMobileBtn(hover) {
      // Solo cambia el color cuando la navbar está fija (imitando tu lógica previa);
      // si prefieres siempre, quita la condición
      const btn = document.getElementById('btnMobileNav')
      if (!btn) return
      if (hover) {
        btn.style.color = this.fixed ? 'rgb(253, 181, 181)' : 'crimson'
      } else {
        btn.style.color = ''
      }
    },
    goHome() {
      if(this.isOpen){
        window.location.hash = '#'
        this.closeIfMobile()
      }
    },

    // ====== moverImagen (opcional, llamado solo si existe #contenedor) ======
    moverImagen(e) {
      const contenedor = document.getElementById('contenedor')
      const imagen = document.getElementById('imagen')
      if (!contenedor || !imagen) return

      const rect = contenedor.getBoundingClientRect()
      const mouseX = e.clientX - rect.left
      const mouseY = e.clientY - rect.top

      const imagenX = (mouseX / rect.width - 0.5) * 20
      const imagenY = (mouseY / rect.height - 0.5) * 20

      imagen.style.transform = `translate(${imagenX}px, ${imagenY}px)`
    },

    // ====== Logout (tu lógica original) ======
    logout() {
      const payload = { token: store.token }
      fetch(process.env.VUE_APP_API_URL + "/users/logout", Security.requestOptions(payload))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            console.log(response.message)
          } else {
            store.token = ""
            store.user = {}
            document.cookie =
              '_site_data=; Path=/; SameSite=Strict; Secure; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
            router.push("/login")
          }
        })
    },
  },
}
</script>

<style>
.logo{
  cursor: pointer;
  color: white;
  text-decoration: none;
}
</style>